import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useSelector } from "react-redux";
import { Card, CardHeader, CardBody, CardHeaderToolbar} from "../../../../../_metronic/_partials/controls";
import * as moment from 'moment'
import {toast} from 'react-toastify'
import { toastOption } from "../../../../../_metronic/_helpers";

export const PartnerQuotaHistoryDetails = ({}) => {
  const {entities, error} = useSelector((state) => state.partnerQuota)
  
  if(error) {
    toast.error(error, toastOption)
  }
  
  const columns = [
    {
      dataField: "thk_partner.name",
      text: "Mitra",
    },
    {
      dataField: "thk_livestock.name",
      text: "Hewan",
    },
    {
      dataField: "thk_area.name",
      text: "Wilayah",
    },
    {
      dataField: "price",
      text: "Harga",
    },
    {
      dataField: "qty",
      text: "Jumlah",
    },
    {
      dataField: "description",
      text: "Deskripsi",
    },
    {
      dataField: "createdAt",
      text: "Tanggal",
      formatter: (cell) => {
        return <>{cell ? moment(cell).format("YYYY:MM:DD HH:mm:ss") : ""}</>
      }
    },
  ];
  
  return (
    <Card>
      <CardHeader title="Riwayat Kuota">
        <CardHeaderToolbar></CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <BootstrapTable
          wrapperClasses="table-responsive"
          classes="table table-head-custom table-vertical-center overflow-hidden"
          bootstrap4
          bordered={false}
          remote
          keyField="uuid"
          data={entities ?? []}
          columns={columns}          
        />
      </CardBody>
    </Card>
  );
}
